import React from 'react';
import { TableHead, TableRow, TableCell, useTheme, Stack, Checkbox } from '@mui/material';
import './table.scss';
import FilterWithSorting from './FilterWithSorting';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';

export default function EnchanedFilterTableHeader({ columns, onChangeFilter, themeType = 1, tableHeadBgColor, sortChange, onSelectCheckBox, isChecked = false }) {
  const theme = useTheme();
  const { t } = useTranslation();

  const onChangeFilterValue = (value) => {
    onChangeFilter(value);
  };

  return (
    <>
      <TableHead
        className="mainUserTableHead"
        style={{ backgroundColor: tableHeadBgColor }}
      >
        <TableRow
          sx={{
            '& th': {
              backgroundColor: tableHeadBgColor ? tableHeadBgColor : themeType === 1 ? theme.palette.grey.light : '#fff',
              borderBottom: themeType === 2 ? '1px solid rgba(224, 224, 224, 1)' : 'none',
            },
          }}
        >
          {columns?.map((headData, index) => (
            <>
              {headData?.accessor === 'Sno' ? (
                /* table serial number header */
                <TableCell
                  key={index}
                  className={"!text-[12px] " + (Boolean(onSelectCheckBox) ? '!pl-[6px] ' : '  !pl-[25px]')}

                  style={{ width: headData?.width, color: theme.palette.primary.text }}
                >
                  {!Boolean(onSelectCheckBox) ? headData.header : <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      if (onSelectCheckBox) {
                        onSelectCheckBox(e.target.checked)
                      }
                    }} />}

                </TableCell>
              ) : (
                /* table other header */
                <TableCell
                  className={`!text-[12px]`}
                  key={index}
                  style={{ width: headData?.width, color: theme.palette.primary.text }}
                >
                  <Stack
                    flexDirection="row"
                    justifyContent={index === columns?.length - 1 && headData?.jcc ? 'center' : 'space-between'}
                  >
                    {!Boolean(headData?.filter?.filterType) && !headData?.icon ? t(headData?.header) : null}

                    {Boolean(headData?.filter?.filterType) && !headData?.icon && (
                      <FilterWithSorting
                        headData={headData}
                        onChange={(data) => {
                          onChangeFilterValue(data);
                        }}
                        sortChange={(data) => {
                          if (sortChange) {
                            sortChange(data);
                          }
                        }}
                      />
                    )}
                  </Stack>
                  {headData?.icon && <Stack sx={{ color: '#006DFF' }}>
                    <ArrowForwardIcon />
                  </Stack>}
                </TableCell>
              )}
            </>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}
